import React, { useState, useEffect } from 'react'
import IntroduceTop from "./introduce-components/introduceTop"
import IntroBtns from "./introduce-components/introBtns"
import IntroRooms from "./introduce-components/introRooms"
import IntroTime from "./introduce-components/introTime"
import IntroEvents from "./introduce-components/introEvents"
import IntroVoices from "./introduce-components/introVoices"
import IntroChief from "./introduce-components/introChief"
import { db } from "../config/firebase"
import { createGlobalStyle } from "styled-components"
import media from "styled-media-query"

const Introduce = () => {

   const [voices, setVoices] = useState([{}])

   useEffect(() => {
      db.collection("voices")
         .onSnapshot((snapShot) => {
            const list = snapShot.docs.map((doc) => {
               const content = doc.data()
               content.id = doc.id
               return content
            })
            const asc = (n, m) => {
               return n.order - m.order
            }
            setVoices(list.sort(asc))
         })
      }, [])
      
   return (
      <>
         <IntroGlobalStyles />
         <IntroduceTop />
         <IntroBtns />
         <IntroRooms />
         <IntroTime />
         <IntroEvents />
         <IntroVoices voices={voices} />
         <IntroChief />
      </>
   )
}

const IntroGlobalStyles = createGlobalStyle`
   #rooms, #timetable, #events, #profile, #voices {
      padding: 70px 0;
      ${media.lessThan("600px")`
         padding: 30px 0;
      `}
      h3 {
         text-align: center;
         font-size: 3rem;
         ${media.lessThan("600px")`
            font-size: 2.2rem;
         `}
      }
   } 
`

export default Introduce